import {
  CreateReeferTemperatureCommand,
  ReeferTemperatureDto,
  UpdateReeferTemperatureCommand,
} from '@operations/app/api'
import dayjs from 'dayjs'
import { ReeferMonitoringFormProfile } from './reefer-monitoring-form.profile'

const mapFormValuesToCreateDto = ({
  cargoUnitJourneyId,
  isPluggedIn,
  temperature,
  humidity,
  ventilation,
  recordedAt,
  additionalInfo,
}: ReeferMonitoringFormProfile): CreateReeferTemperatureCommand => ({
  cargoUnitJourneyId: +cargoUnitJourneyId!,
  isPluggedIn,
  temperature: temperature ? +temperature : undefined,
  humidity: humidity ? +humidity : undefined,
  ventilation: ventilation ? +ventilation : undefined,
  recordedAt: dayjs(recordedAt).toISOString(),
  additionalInfo: additionalInfo,
})

const mapFormValuesToUpdateDto = ({
  id,
  isPluggedIn,
  temperature,
  humidity,
  ventilation,
  recordedAt,
  additionalInfo,
}: ReeferMonitoringFormProfile): UpdateReeferTemperatureCommand => ({
  id: id!,
  isPluggedIn,
  temperature: temperature ? +temperature : undefined,
  humidity: humidity ? +humidity : undefined,
  ventilation: ventilation ? +ventilation : undefined,
  recordedAt: dayjs(recordedAt).toISOString(),
  additionalInfo: additionalInfo,
})

const mapDtoToFormValues = ({
  id,
  cargoUnitJourneyId,
  isPluggedIn,
  temperature,
  humidity,
  ventilation,
  recordedAt,
  additionalInfo,
}: ReeferTemperatureDto): ReeferMonitoringFormProfile => ({
  id,
  cargoUnitJourneyId,
  isPluggedIn,
  temperature,
  humidity,
  ventilation,
  recordedAt: new Date(recordedAt),
  additionalInfo: additionalInfo ?? undefined,
})

export const ReeferMonitoringFormMapper = {
  mapFormValuesToCreateDto,
  mapFormValuesToUpdateDto,
  mapDtoToFormValues,
}
